import React from "react";
import "../assets/css/UnitRadioGroup.css"; // pour le style custom

const UnitRadioGroup = ({ allUnits, selected, onChange }) => {
  return (
   <div id="unitSelector" className="btn-group" role="group" aria-label="Unit Selector">
      {allUnits && allUnits.map((unit) => {
        const uid = String(unit.id);
        const checked = String(selected) === uid;
        return (
          <React.Fragment key={uid}>
            <input
              type="radio"
              className="btn-check"
              name="unitSelector"
              id={`unit-${uid}`}
              value={uid}
              checked={checked}
              onChange={() => onChange(uid)}
            />
            <label className="btn btn-outline-primary" htmlFor={`unit-${uid}`}>
              {unit.label_fr}
            </label>
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default UnitRadioGroup;
